(function(window) {
    'use strict'

    const internal = window.RTAnalyticsInternal

    function attemptDelivery(delivery) {
        if (!internal.providers.isReady(delivery)) {
            return Promise.resolve(false)
        }

        return internal.storage.claimDelivery(delivery.id).then(function(claimedDelivery) {
            if (!claimedDelivery) {
                return false
            }

            return internal.providers.send(claimedDelivery).then(function(dispatched) {
                return internal.storage.markAttempted(claimedDelivery.id, dispatched).then(function() {
                    return dispatched
                })
            })
        })
    }

    function attemptDirect(deliveries) {
        return Promise.all(deliveries.map(function(delivery) {
            if (!internal.providers.isReady(delivery)) {
                return false
            }

            return internal.providers.send(delivery)
        }))
    }

    function flushEvent(eventId) {
        return internal.storage.getQueuedDeliveries(
            internal.config.maxFlushDeliveries,
            eventId
        ).then(function(deliveries) {
            return Promise.all(deliveries.map(attemptDelivery))
        })
    }

    function flush() {
        return internal.storage.getQueuedDeliveries(
            internal.config.maxFlushDeliveries
        ).then(function(deliveries) {
            return Promise.all(deliveries.map(attemptDelivery))
        })
    }

    internal.outbox = Object.freeze({
        attemptDirect: attemptDirect,
        flushEvent: flushEvent,
        flush: flush
    })
})(window)
